const Program = class Field {
    constructor() {
        this.title = '';
        this.sessions = [];
        this.emails = [];
    }
};

export default Program;
